import { CodeHighlight } from '@mantine/code-highlight';
import dedent from 'dedent';
import { AvailableLibraryList } from '~/components/codeEditor/AvailableLibraryList';

export const DynamicVariableGuide = () => {
  return (
    <div className="px-2">
      <h3 className="mb-2 font-medium">Using Variables</h3>
      <div className="mb-4 text-sm text-gray-700 dark:text-gray-300">
        Use <code className="rounded bg-gray-100 px-1 py-0.5 dark:bg-gray-800">VARS</code> to access variables defined
        in your test or on the project.
      </div>

      <h3 className="mb-2 font-medium">Writing Dynamic Expressions</h3>
      <div className="mb-4 text-sm text-gray-700 dark:text-gray-300">
        <p className="mb-2">
          Write the variable value as if it is the right-hand side of a variable declaration (no semi-colon required).
          Here are a few examples of valid dynamic variable values:
        </p>

        <CodeHighlight
          code={dedent`
            faker.internet.password()
            \`user-$\{faker.internet.email()}-$\{Date.now()}\`
            Math.floor(Math.random() * VARS.previouslyDefinedNumber)
          `}
          language="tsx"
        />

        <p className="mb-2 mt-2">
          Each of these variable definitions will generate a unique value every time the step is executed.
        </p>
      </div>

      <h3 className="mb-2 font-medium">Available Libraries</h3>
      <AvailableLibraryList />
    </div>
  );
};
